import React from 'react';

const RehireIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M9 19L4 14L9 9M18 4V14H5' stroke='#5C5963' strokeWidth='2' />
    </svg>
  );
};

export default RehireIcon;
